module.exports = __webpack_public_path__ + "img/flag-FRANCE.da1cb61c.svg";